import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { BrowserAgent } from '@newrelic/browser-agent';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';

const options = {
  init: [environment.nrInit], 
  info: [environment.nrInfo], 
  loader_config: [environment.nrLoaderConfig]
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'aprobacionfacturas';

  constructor(private gtmServices: GoogleTagManagerService, private router: Router, private authServices: AuthService) {

    new BrowserAgent(options);

    this.authServices.generarDatosUsuario();

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        this.gtmServices.pushTag(gtmTag);
      }
    });
  }
}
